module.exports = __webpack_public_path__ + "static/media/rutuja_dautpure.d0fb0205.png";